export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";

/**
 * Reset CHANGE PASSWORD
 */
export const RESET_CHANGE_PASSWORD_STATUS = "RESET_CHANGE_PASSWORD_STATUS";
export const RESET_CHANGE_PASSWORD_ERROR = "RESET_CHANGE_PASSWORD_ERROR";
